import { DateTime } from "luxon"
import React, { useMemo, useState } from 'react'
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers"
import LuxonAdapter from '@date-io/luxon'
import { useLocale } from 'shared/Modules/Localization/useLocale'
import Button from 'shared/Components/Button'
import { Localized, useLocalization } from "@fluent/react"
import { getAmPm } from "shared/Helpers/DateTimeHelper"

type ValueType = DateTime | null

interface IOwnProps {
    buttonLabel: string
    value: ValueType
    onChange: (value: ValueType) => any
}

type IProps = IOwnProps

const getValue = (value: ValueType) => value ?? DateTime.local()

const CustomDateTimePicker = (props: IProps) => {
    const { buttonLabel, onChange, value } = props

    const { l10n } = useLocalization()
    const locale = useLocale()
    const inputValue = useMemo(() => getValue(value), [value])
    const [isOpen, setOpen] = useState(false)

    const handleDateChange = (date: ValueType) => {
        onChange(date)
        setOpen(false)
    }

    const TextFieldComponent = () => {
        return (
            <Button onClick={() => {
                setOpen(true)
            }}>
                {buttonLabel}
            </Button>
        )
    }

    return (
        <MuiPickersUtilsProvider utils={LuxonAdapter} locale={locale}>
            <Localized id="date-time-picker" attrs={{ okLabel: true, cancelLabel: true }}>
                <DateTimePicker
                    value={inputValue}
                    onChange={handleDateChange}
                    TextFieldComponent={TextFieldComponent}
                    minutesStep={5}
                    open={isOpen}
                    okLabel="OK"
                    cancelLabel="Cancel"
                    ampm={getAmPm(l10n, locale)}
                />
            </Localized>
        </MuiPickersUtilsProvider>
    )
}

export default CustomDateTimePicker
